import React from 'react';
import ZonePolygon from './zone-polygon';

function ZonePolygons({
  zones, editable, onZoneBoundaryEdit, showLabels, vehicles,
}) {
  return (
    <>
      {zones.map((zone) => (
        <ZonePolygon
          key={zone._id}
          zone={zone}
          editable={editable}
          onZoneBoundaryEdit={onZoneBoundaryEdit}
          showLabels={showLabels}
          vehicles={vehicles}
        />
      ))}
    </>
  );
}

export default ZonePolygons;
